import React from "react"
import { PopupCanvas } from "@infotech/uikit-popup-factory"
import { BrowserRouter, Route } from "react-router-dom"
import { QueryParamProvider } from "use-query-params"

export default () => () => ({ App, children }) => ({
  App: () => (
    <BrowserRouter>
      <QueryParamProvider ReactRouterRoute={Route}>
        <PopupCanvas>{children}</PopupCanvas>
        <App />
      </QueryParamProvider>
    </BrowserRouter>
  ),
})
